export const PARTNER_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

// A slug becomes one DNS label of `<slug>.procertcompliance.com`, so it is
// capped at the 63-character label limit and cannot claim a platform host.
export const PARTNER_SLUG_MAX_LENGTH = 63;
export const RESERVED_PARTNER_SLUGS = Object.freeze([
  "www",
  "connect",
  "api",
  "app",
  "admin",
  "mail",
  "partner",
]);

export const normalizePartnerSlug = (slug) =>
  String(slug || "")
    .trim()
    .toLowerCase();

export const isSafePartnerSlug = (slug) => {
  const cleanSlug = normalizePartnerSlug(slug);
  return (
    cleanSlug.length >= 2 &&
    cleanSlug.length <= PARTNER_SLUG_MAX_LENGTH &&
    PARTNER_SLUG_PATTERN.test(cleanSlug) &&
    !RESERVED_PARTNER_SLUGS.includes(cleanSlug)
  );
};

export const assertSafePartnerSlug = (slug) => {
  const cleanSlug = normalizePartnerSlug(slug);
  if (!isSafePartnerSlug(cleanSlug)) {
    throw new Error("Invalid partner slug");
  }
  return cleanSlug;
};
